import { useEffect, useState } from "react";
import { Duration, toSeconds } from "iso8601-duration";

import { getPickupReadinessTime } from "@/api/requests/getPickupReadinessTime";

import useDomainCountryCode from "./useDomainCountryCode";

export const useGetPickupReadinessTime = (dispensaryId: number) => {
  const [hasPickupLabel, setHasPickupLabel] = useState(false);
  const [pickupReadinessIsLoading, setPickupReadinessIsLoading] =
    useState(true);
  const [pickupReadinessErrors, setPickupReadinessErrors] = useState(false);
  const domainCountryCode = useDomainCountryCode();

  useEffect(() => {
    getPickupReadinessTime({
      dispensaryId,
      domainCountryCode,
    })
      .then(hasPickupReadinessLabel)
      .then(setHasPickupLabel)
      .catch(() => setPickupReadinessErrors(true))
      .finally(() => setPickupReadinessIsLoading(false));
  }, [dispensaryId]);

  return {
    hasPickupLabel,
    pickupReadinessErrors,
    pickupReadinessIsLoading,
  };
};

const hasPickupReadinessLabel = (duration: Duration | null): boolean => {
  if (!duration) {
    return false;
  }

  const minutes = toSeconds(duration) / 60;
  return minutes < 30;
};
